export const ScreenUnknown = 0;
export const ScreenGlobalSettings = 1;
export const ScreenMyCompany = 2;
export const ScreenCompanies = 3;
export const ScreenGlobalUsers = 4;
export const ScreenDataSources = 5;
export const ScreenPathCredentials = 6;
export const ScreenRoleGroups = 7;
export const ScreenAgents = 8;
export const ScreenWorkspaces = 9;
export const ScreenWorkspaceSettings = 10;
export const ScreenWorkspaceUsers = 11;
export const ScreenSso = 12;